<template>
  <div class="article-block d-flex">
    <div class="left-img"></div>
    <div class="article-list">
      <li
        class="list-each fs-sm"
        v-for="(item, index) in xxData"
        :key="item.id"
        @mouseenter="liHover(index)"
        :class="{ 'pt-8': index == currIndex }"
      >
        <div class="li-img" v-show="index == currIndex">
          <img :src="item.cover" />
        </div>
        <div v-show="index != currIndex">
          <div class="j-flex">
            <div class="d-flex title">
              <div class="circle"></div>
              <div class="overflow" style="width: 450px">{{ item.title }}</div>
            </div>
            <div class="date">{{ item.publishDate | formateDate }}</div>
          </div>
        </div>
        <div v-show="index == currIndex" @click="lookDetail(item)">
          <div class="j-flex" style="margin-top: 8px">
            <div class="d-flex">
              <div class="j-flex">
                <img src="../../../assets/img/Polygon.svg" />
                <div class="hover-title fs-xl overflow">{{ item.title }}</div>
              </div>
            </div>
            <div class="date">{{ item.publishDate | formateDate }}</div>
          </div>
          <div
            class="detail-head overflow2"
            style="margin-bottom: 6px"
            v-if="item.subtitle != '' && item.subtitle != null"
          >
            {{ item.subtitle }}
          </div>
        </div>
      </li>
    </div>
  </div>
</template>
<script>
import { formateDate } from '../../../assets/js/date'
export default {
  props: ['xxData'],
  data() {
    return {
      currImg: require('../../../assets/img/image.png'),
      article: [],
      currIndex: 0,
    }
  },
  filters: {
    formateDate(time) {
      let date = new Date(time)
      return formateDate(date, 'yyyy-MM-dd').slice(5, 10)
    },
  },
  created() {},

  methods: {
    liHover(i) {
      this.currIndex = i
      this.currImg = this.xxData[i].picture
    },
    lookDetail(item) {
      this.$router.push({
        path: '/article',
        query: {
          one: '新闻报道',
          two: '学校新闻',
          three: '',
          path: '/report',
          keepalive: 2,
          //   keepchild: this.listChildIndex,
          //   articleId: item.id,
          articleId: item.uuid,
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../../assets/css/main.scss';
.article-block {
  width: 1052px;
  height: 326px;
  background-color: $white;
  padding: 24px;
  margin-top: 24px;
  position: relative;
}
.left-img {
  width: 514px;
  height: 326px;
}
.li-img {
  width: 514px;
  height: 326px;
  position: absolute;
  top: 24px;
  left: 24px;
}
.li-img img {
  width: 100%;
  height: 100%;
}
.article-list {
  width: 514px;
  height: 326px;
  //   border-top: 1px dashed #000000;
  background: url('../../../assets/img/dot.jpg');
  background-repeat: repeat-x;
  background-position: top;
  margin-left: 24px;
}
.circle {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: $mainFont;
  margin-right: 8px;
  margin-left: 8px;
}
.list-each {
  list-style: none;
  color: $mainFont;
  line-height: 36px;
  //   border-bottom: 1px dashed $mainFont;
  background: url('../../../assets/img/dot.jpg');
  background-repeat: repeat-x;
  background-position: bottom;

  cursor: pointer;
}
.title {
  align-items: center;
}
.date {
  color: $lightFont;
}
.hover-title {
  color: $darkGrenn;
  margin-left: 6px;
  height: 34px;
  width: 450px;
}
.detail-head {
  line-height: 22px;
  font-size: 13px;
  color: #747474;
  width: 100%;
  height: 44px;
}
.hover-li {
  padding-top: 12px;
  padding-bottom: 12px;
}
.pt-8 {
  padding-bottom: 8px;
}
</style>
